(function () {
  'use strict';

  var store = null;

  function parseHash() {
    var hash = window.location.hash.replace('#', '');
    var params = {};
    hash.split('&').forEach(function (part) {
      var pair = part.split('=');
      if (pair.length === 2) params[pair[0]] = decodeURIComponent(pair[1]);
    });
    return params;
  }

  function setHash(stepKey) {
    window.location.hash = 'step=' + stepKey;
  }

  function onHashChange() {
    var params = parseHash();
    var stepKey = params.step;
    if (!stepKey) return;

    var seq = store.getStepSequence();
    if (seq.indexOf(stepKey) === -1) return;

    if (!WmpRouter.canNavigateTo(stepKey)) return;

    store.set('currentStep', stepKey);
  }

  var WmpRouter = {
    init: function (storeInstance) {
      store = storeInstance;
      window.addEventListener('hashchange', onHashChange);

      var overlay = document.getElementById('wmp-flow-overlay');
      var overlayVisible = overlay && !overlay.hasAttribute('hidden');

      if (!overlayVisible) {
        // Wipe any stale #step=... from the URL. Otherwise the flow deadlocks
        // the first time advance() tries to setHash() to that same value —
        // hashchange doesn't fire for a no-op assignment.
        if (window.location.hash) {
          history.replaceState(null, '', window.location.pathname + window.location.search);
        }
        return;
      }

      var params = parseHash();
      if (params.step && store.getStepSequence().indexOf(params.step) > -1) {
        store.set('currentStep', params.step);
      } else {
        setHash(store.get('currentStep'));
      }
    },

    navigate: function (stepKey) {
      if (!this.canNavigateTo(stepKey)) return;
      setHash(stepKey);
    },

    advance: function () {
      var seq = store.getStepSequence();
      var current = store.get('currentStep');
      var idx = seq.indexOf(current);

      store.markCompleted(current);

      if (store.get('editingFromReview')) {
        store.set('editingFromReview', false);
        setHash('review');
        return;
      }

      if (idx < seq.length - 1) {
        setHash(seq[idx + 1]);
      }
    },

    back: function () {
      var seq = store.getStepSequence();
      var current = store.get('currentStep');
      var idx = seq.indexOf(current);

      store.set('editingFromReview', false);

      if (idx > 0) {
        store.resetStepsAfter(seq[idx - 1]);
        setHash(seq[idx - 1]);
      }
    },

    canNavigateTo: function (stepKey) {
      var seq = store.getStepSequence();
      var targetIdx = seq.indexOf(stepKey);
      if (targetIdx === -1) return false;
      if (targetIdx === 0) return true;

      var current = store.get('currentStep');
      var currentIdx = seq.indexOf(current);

      if (targetIdx <= currentIdx) return true;
      if (store.isCompleted(stepKey)) return true;

      var prevStep = seq[targetIdx - 1];
      return store.isCompleted(prevStep);
    },

    getCurrentIndex: function () {
      var seq = store.getStepSequence();
      return seq.indexOf(store.get('currentStep'));
    },

    getTotalSteps: function () {
      return store.getStepSequence().length;
    },

    destroy: function () {
      window.removeEventListener('hashchange', onHashChange);
    }
  };

  window.WmpRouter = WmpRouter;
})();
